import { getTracks, getDevicesByCarVin } from '@/api/device'
const map = {
  namespaced: true,
  state: {
    tracks: []
  },
  mutations: {
    setTracks: (state, tracks) => {
      state.tracks = tracks
    }
  },
  getters: {
    tracks: ({ tracks }) => tracks
  },
  actions: {
    async getTracks({ commit }, parameter) {
      const res = await getTracks(parameter)
      let data = res?.content ?? []
      commit('setTracks', data)
      return res
    },
    async getCarDevices(_, parameter) {
      const res = await getDevicesByCarVin(parameter)
      // let data = res?.content ?? []
      // commit('setTracks', data)
      return res
    }
  }
}
export default map
